import { useFiltersApi } from '../useApi/useFiltersApi/useFiltersApi'
import { useAnalyticsFiltersGetParams } from '@/features/Analytics/hooks/useAnalyticsFiltersGetParams'
import { useAnalyticsFiltersStore } from '@/features/Analytics/stores/useAnalyticsFiltersStore/useAnalyticsFiltersStore'

export const useNodesCommoditiesFiltersError = () => {
    const { useNodesQuery, useCommoditiesQuery } = useFiltersApi()
    const activeFilters = useAnalyticsFiltersStore(
        (state) => state.activeFilters
    )
    const params = useAnalyticsFiltersGetParams(activeFilters)

    const nodesQuery = useNodesQuery()
    const commoditiesQuery = useCommoditiesQuery({
        'nodeIds[]': params['nodeIds[]'],
    })

    const isFiltersError = nodesQuery.isError || commoditiesQuery.isError

    return {
        isFiltersError,
    }
}
